"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPOSITE_KEY_SEPARATOR = void 0;
exports.normalizeForComparison = normalizeForComparison;
exports.compositeKey = compositeKey;
exports.indexByKey = indexByKey;
const defaultColumnNormalizer = (_column, value) => normalizeForComparison(value);
function normalizeForComparison(value) {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'number') {
        return Number.isFinite(value) ? String(value) : '';
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        const asNumber = Number(trimmed);
        if (trimmed !== '' && !Number.isNaN(asNumber)) {
            return String(asNumber);
        }
        return trimmed;
    }
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }
    return JSON.stringify(value);
}
exports.COMPOSITE_KEY_SEPARATOR = '\x1F';
function compositeKey(row, alignOnKeys, normalize = defaultColumnNormalizer) {
    const r = row;
    return alignOnKeys.map((k) => normalize(k, r[k], r)).join(exports.COMPOSITE_KEY_SEPARATOR);
}
function indexByKey(rows, alignOnKeys, normalize = defaultColumnNormalizer, onDuplicate) {
    const map = new Map();
    for (const row of rows) {
        const key = compositeKey(row, alignOnKeys, normalize);
        const kept = map.get(key);
        if (kept !== undefined) {
            onDuplicate?.(key, kept, row);
            continue;
        }
        map.set(key, row);
    }
    return map;
}
//# sourceMappingURL=value-comparison.js.map